import { mixinDevice } from '@/utils/mixin.js'

const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
const passwordMixins = {
  mixins: [mixinDevice],
  data() {
    return {
      imageCodeUrl: '',
      imageCode: '',//图片验证码
      randomNum: 0,
      visible: false,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 0,
        progressColor: '#FF0000'
      }
    }
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel]
    }
  },
  methods: {
    resetState() {
      this.state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 0,
        progressColor: '#FF0000'
      }
    },
    //重置图片验证码地址
    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    },
    //获取密码强度等级
    getPasswordLevel(value) {
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      return level
    },
    handlePasswordLevel(rule, value, callback) {
      let level = this.getPasswordLevel(value)
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback(new Error('密码强度不够'))
      }
    },

    handlePasswordCheck(rule, value, callback) {
      const password = this.form.getFieldValue('password')
      this.getLogUtils().logWithTag('value', value)
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    handlePasswordInputClick() {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true
        return
      }
      this.state.passwordLevelChecked = false
    },
    //验证码请求
    requestCaptcha(mobile, params) {
      this.state.smsSendBtn = true
      const interval = window.setInterval(() => {
        if (this.state.time-- <= 0) {
          this.state.time = 60
          this.state.smsSendBtn = false
          window.clearInterval(interval)
        }
      }, 1000)
      const hide = this.$message.loading('验证码发送中..', 0)
      const requestParams = {
        effect: 6,
        isValidationImg: false,
        mobile: mobile,
        randomNum: params.randomNum,
        verificationImg: params.imageCode,
        userType: 1
      }
      this.getHttpServices().getBaseService().post('sms/verification', requestParams)
        .then(res => {
          setTimeout(hide, 2500)
          this.$notification['success']({
            message: '提示',
            description: '验证码已发送，请注意查收',
            duration: 8
          })
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        setTimeout(hide, 1)
        clearInterval(interval)
        this.state.time = 60
        this.state.smsSendBtn = false
      })
    }
  }
}
export default passwordMixins